module.exports = __webpack_public_path__ + "img/img1.1a70d4a9.png";